export default "__VITE_ASSET__85cf33d2__"